import { createSelector } from "@reduxjs/toolkit";

import selectData from "../selectData";

const selectError = createSelector([selectData], (data) => data.error);

export default selectError;
